// filepath: apps/web/src/editors/bpm-designer/InlineNodeError.tsx
//
// FR-UI-BLD-1 AC-4 - inline error chip next to a node on the BPM
// designer canvas. Rendered as a text node (INV-9) carrying the
// server's error message verbatim.

import React from "react";
import { useTranslation } from "react-i18next";
import type { ValidationErrorWire } from "./types";

interface InlineNodeErrorProps {
  nodeId: string;
  errors: ValidationErrorWire[];
}

export function InlineNodeError({
  nodeId,
  errors,
}: InlineNodeErrorProps): React.ReactElement | null {
  const { t } = useTranslation();
  const matching = errors.filter((e) => e.node_id === nodeId);
  if (matching.length === 0) {
    return null;
  }
  return (
    <div
      className="inline-node-error"
      role="alert"
      data-testid={`inline-node-error-${nodeId}`}
    >
      {matching.map((err, idx) => (
        <span
          key={`${err.node_id}-${err.field ?? ""}-${idx}`}
          className="inline-node-error__chip"
          data-error-type={err.type}
        >
          {err.message}
          {err.field && (
            <small className="inline-node-error__field">
              {` (${err.field})`}
            </small>
          )}
        </span>
      ))}
      <span className="sr-only">{t("admin.designer.save.invalid")}</span>
    </div>
  );
}
